import React from 'react';
import PropTypes from 'prop-types';

function SizeDisplay({ size, sizeUnit }) {
    const isEmpty = size == null;

    if (isEmpty) {
        return null;
    }

    if (sizeUnit === 'm2') {
        return <>
            {size} m<sup>2</sup>
        </>;
    } else if (sizeUnit === 'ft2') {
        return <>
            {size} ft<sup>2</sup>
        </>;
    } else {
        return `${size} ${sizeUnit}`;
    }
}

SizeDisplay.propTypes = {
    size: PropTypes.number,
    sizeUnit: PropTypes.string,
};

SizeDisplay.defaultProps = {
    size: null,
    sizeUnit: null,
};

export default SizeDisplay;
